import React from 'react'

import Button from '@/components/shared/ui/Button'
import type { ButtonProps } from '@/components/shared/ui/Button/Button'
import { MicrosoftIcon } from '@/components/shared/ui/Icons'
import { authRedirectingPath } from '@/lib/helpers/pathHelpers'
import { buildURL } from '@/lib/helpers/urlHelpers'

const generateURL = (redirectURL: string) =>
  buildURL('https://login.microsoftonline.com/common/oauth2/v2.0/authorize', {
    client_id: process.env.NEXT_PUBLIC_AZURE_AD_CLIENT_ID,
    redirect_uri: `${process.env.NEXT_PUBLIC_HOSTED_URL}/api/auth/callback/azure-ad`,
    scope: 'User.Read',
    response_mode: 'form_post',
    state: `${redirectURL}`,
    response_type: 'code',
  })

interface IPropTypes extends ButtonProps {
  className: string
  label: string
  onButtonClick: (url: string) => any
}

export default function MicrosoftSigninButton({
  className,
  label,
  onButtonClick,
  size,
}: IPropTypes) {
  return (
    <Button
      dataTestId='microsoft_signin_button'
      className={className}
      variant='outline'
      size={size || 'md'}
      onClick={() =>
        onButtonClick(
          generateURL(`${window.location.origin}${authRedirectingPath}`)
        )
      }
      icon={<MicrosoftIcon className={'h-5 w-5'} />}
      block
    >
      {label}
    </Button>
  )
}
